// Styles
import '@design-system/setup';
import '@/assets/css/main.css'; // Version 4.4
import '@/assets/scss/mo-custom.scss';
import '@/assets/css/plugins/fontello/css/fontello.css';

import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n/i18n';
import router from './router';
import store from './vuex/vuex';
import { mapState, mapMutations, mapActions } from 'vuex';
import { onHttpError } from './lib/error_handling';

// Frameworks/Plugins
import '@/core/use';
import '@design-system/setup';
import moment from 'moment';

// Prototypes
import '@/prototypes';

// Analyzer - Mixpanel
import { analyzer } from '@/analyzer';

// Filters
import '@/filters';
import './quasar';

// Sentry
import { initializeSentry } from '@/sentry.config';
initializeSentry();

// Intercom
import { setIntercomConfig } from '@/intercom';

//error boundary
import ErrorBoundary from '@/layouts/ErrorBoundary.vue';
Vue.component('ErrorBoundary', ErrorBoundary);

Vue.config.productionTip = false;
window.moment = moment;

export const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    //Intercom
    // var APP_ID = 'ulft8mzv';

    // (function() {
    //   var w = window;
    //   var ic = w.Intercom;
    //   if (typeof ic === 'function') {
    //     ic('reattach_activator');
    //     ic('update', w.intercomSettings);
    //   } else {
    //     var d = document;
    //     var i = function() {
    //       i.c(arguments);
    //     };
    //     i.q = [];
    //     i.c = function(args) {
    //       i.q.push(args);
    //     };
    //     w.Intercom = i;
    //     var l = function() {
    //       var s = d.createElement('script');
    //       s.type = 'text/javascript';
    //       s.async = true;
    //       s.src = 'https://widget.intercom.io/widget/' + APP_ID;
    //       var x = d.getElementsByTagName('script')[0];
    //       x.parentNode.insertBefore(s, x);
    //     };
    //     if (document.readyState === 'complete') {
    //       l();
    //     } else if (w.attachEvent) {
    //       w.attachEvent('onload', l);
    //     } else {
    //       w.addEventListener('load', l, false);
    //     }
    //   }
    // })();
    //Intercom

    // ログインページでの動作
    this._route.path !== '/login' &&
    this._route.path !== '/ripple/login' &&
    this._route.path !== '/saml' &&
    this._route.path !== '/'
      ? this.loadInitialData().catch(onHttpError)
      : this.updateLoadingState(false);
  },
  computed: {
    ...mapState('user', {
      user: state => state.data,
    }),
  },
  methods: {
    ...mapMutations({
      updateLoadingState: 'updateLoadingState',
      updateLanguage: 'updateLanguage',
    }),

    ...mapActions(['fetchVendor']),

    ...mapActions('auth', {
      checkToken: 'checkToken',
      setAccessToken: 'setAccessToken',
    }),

    ...mapActions('rbac', {
      getUserPermission: 'getUserPermission',
    }),

    ...mapActions('globalFlags', {
      fetchGlobalFlag: 'fetchGlobalFlag',
    }),

    ...mapActions('status', {
      getUserStatus: 'getUserStatus',
    }),

    ...mapActions('announcements', ['fetchAnnouncements']),

    ...mapActions('user', {
      getUser: 'fetchUser',
      fetchUserLogo: 'fetchUserLogo',
      fetchAccessGroup: 'fetchAccessGroup',
    }),

    ...mapActions('personal', {
      fetchPersonalData: 'fetch',
    }),

    async loadInitialData(login) {
      this.updateLoadingState(true);
      try {
        const token = await this.checkToken(); // Tokenのチェック

        await this.setAccessToken(token); // Tokenをaxiosにセット
        await this.fetchVendor();
        await this.getUser().catch(onHttpError); // User Info
        await this.getUserPermission().catch(onHttpError); // User Permissions
        await this.fetchPersonalData().catch(onHttpError); // User Permissions
        await this.getUserStatus().catch(onHttpError); // User Status
        await this.fetchAnnouncements().catch(onHttpError); // Announcements
        await this.fetchGlobalFlag().catch(onHttpError); // Global Flags
        if (this.user.access_group) {
          await this.fetchAccessGroup().catch(onHttpError); // BillingGroups
        }
        // await this.fetchUserLogo().catch(onHttpError); // ユーザーロゴ取得
        // await window.Intercom('boot', setIntercomConfig(this.user)); // Intercom config

        await window.Intercom('boot', setIntercomConfig(this.user));

        await analyzer.register(this.user['user_id'], {
          username: this.user['company_name'],
          is_admin: this.user['sub_username'] ? false : true,
          sub_username: this.user['sub_username'],
          msp_id: this.user['msp_id'],
        });

        if (this.$route.path !== '/dashboard' && this.$route.path !== '/ripple/login') {
          await this.checkPermission();
        }
      } catch (err) {
        // AccessTokenが無い場合
        if (err === 'Access token not found.') {
          console.error(err);
        } else if (err === 'Access denied.') {
          // パーミッションエラー
          console.error(err);
        } else {
          // その他のエラー
          console.error(err);
          console.error('Failed to load initial data');
        }
      } finally {
        if (login) {
          await this.$router.replace('/dashboard').catch(() => {});
        }
        this.updateLoadingState(false);
      }
    },

    checkPermission() {
      if (this.$can(this._route.path)) {
        return Promise.resolve();
      } else {
        return Promise.reject('Access denied.');
      }
    },
  },
}).$mount('#app');
